"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumb = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Breadcrumb = _interopRequireDefault(require("react-bootstrap/Breadcrumb"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Breadcrumb = function Breadcrumb(_ref) {
  var dropLast = _ref.dropLast,
      links = _ref.links,
      _ref$as = _ref.as,
      Heading = _ref$as === void 0 ? "h1" : _ref$as,
      headingClassName = _ref.headingClassName,
      breadcrumbItemProps = _ref.breadcrumbItemProps,
      linkProps = _ref.linkProps,
      props = _objectWithoutProperties(_ref, ["dropLast", "links", "as", "headingClassName", "breadcrumbItemProps", "linkProps"]);

  var headingClasses = (0, _classnames["default"])("h2", headingClassName);
  return /*#__PURE__*/_react["default"].createElement(_Breadcrumb["default"], _extends({
    listProps: dropLast && {
      className: "uxf-breadcrumb-drop-last"
    }
  }, props), links.map(function (link) {
    if (links.indexOf(link) !== links.length - 1) {
      return /*#__PURE__*/_react["default"].createElement(_Breadcrumb["default"].Item, _extends({
        href: link.href,
        key: link.href || link.to,
        linkProps: _objectSpread({
          to: link.to
        }, linkProps)
      }, breadcrumbItemProps), link.title);
    } else {
      return /*#__PURE__*/_react["default"].createElement(_Breadcrumb["default"].Item, _extends({
        active: true,
        "aria-current": "page",
        key: link.href || link.to,
        href: link.href,
        linkProps: _objectSpread({
          to: link.to
        }, linkProps)
      }, breadcrumbItemProps), dropLast ? /*#__PURE__*/_react["default"].createElement(Heading, {
        className: headingClasses
      }, link.title) : link.title);
    }
  }));
};

exports.Breadcrumb = Breadcrumb;
Breadcrumb.propTypes = {
  /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'breadcrumb'
   */
  bsPrefix: _propTypes["default"].string,

  /**
   * ARIA label for the nav element
   * https://www.w3.org/TR/wai-aria-practices/#breadcrumb
   */
  label: _propTypes["default"].string,

  /**
   * Additional props passed as-is to the underlying `<ol>` element
   */
  listProps: _propTypes["default"].object,

  /**
   * Additional props passed as-is to the underlying link for non-active items.
   */
  linkProps: _propTypes["default"].object,

  /** Set a custom element for this component */
  as: _propTypes["default"].elementType,

  /**
   * Uses current page in breadcrumb as a page heading
   */
  dropLast: _propTypes["default"].bool.isRequired,

  /**
   * Links included within breadcrumb
   */
  links: _propTypes["default"].array.isRequired,

  /**
   * Classes added to Breadcrumb `dropLast` variation heading
   */
  headingClassName: _propTypes["default"].string,

  /**
   * Additional props passed as-is to the underlying Breadcrumb.Item elements
   */
  breadcrumbItemProps: _propTypes["default"].object
};
Breadcrumb.defaultProps = {
  dropLast: false,
  links: [{
    title: "test1",
    href: "/"
  }, {
    title: "test2",
    href: "/"
  }, {
    title: "test3",
    href: "/"
  }]
};